import { useState } from "react";
// import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../lib/i18n";
import { useRoutePath } from "../../hooks/useRoutePath";
import { useDispatch, useSelector } from "react-redux";
import menuService from "@services/menuService";
import { setProject } from "@modules/project";
import { getSettingsAPI } from "@modules/apis/setting";
import { Breadcrumbs, Typography, Link, Grid, Button } from "@mzc-pdc/ui";

const BreadcrumbsWithRouterPath = ({ isAdmin }) => {
    const routePath = useRoutePath();
    const location = useLocation();
    const newPath = menuService.breadcrumbs(routePath.match.url);
    const { spaceId, projectId } = menuService.parse(location.pathname);
    const splitPath = newPath.replace(/^\//, "").split("/");

    const navigator = useSelector(({ navigator }) => navigator);

    const list = splitPath.map((path, index) => {
        const path_ = path.replace(/^[a-z]/, (c) => c.toUpperCase());
        const i18nKey = `common::label::${path_}`;
        const isKeyExist = i18n.exists(i18nKey);
        const isLastItem = index === splitPath.length - 1;
        let pathValue = path_;
        if (isKeyExist) pathValue = i18n.t(i18nKey);
        const LinkComponent = isLastItem ? Typography : Link;

        if (pathValue === "Sharebox") {
            pathValue = "Shared Box";
        }
        if (pathValue === "Shared History") {
            pathValue = "Shared Histories";
        }
        if (pathValue === "Meetings_old") {
            pathValue = "Meetings";
        }
        if (pathValue === "Project-list") {
            pathValue = "Projects";
        }
        if (pathValue === "Assigned-groups") {
            pathValue = "Groups";
        }
        if (pathValue === "Assigned-users") {
            pathValue = "Users";
        }
        if (menuService.paths.assetsCollectionsSearch(spaceId, projectId).includes(newPath) && pathValue === "Search") {
            pathValue = "Collections Search Results";
        }
        if (
            index > 0 &&
            splitPath[index - 1] === "contents" &&
            !["videos", "photos", "music", "people"].includes(splitPath[index])
        ) {
            pathValue = navigator?.contents?.data?.find(({ id }) => id === path)?.name || "";
        }

        return (
            <Link
                color={isLastItem ? "text.secondary" : "primary"}
                href={
                    `${isAdmin ? "admin" : ""}/spaces/${spaceId}/${projectId ? `projects/${projectId}/` : ""}` +
                    splitPath.slice(0, index + 1).join("/")
                }
                underline="hover"
                variant="body3"
                key={index}
            >
                {pathValue}
            </Link>
        );
    });

    const { asset, project, stage } = useSelector((state) => state);
    const assetProject = asset.data && asset.data.project;
    // console.log('assetProject', assetProject)
    const differentProject = (project && project.id) !== (assetProject && assetProject.id) || false;
    // console.log('location', location)

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [switchPending, setSwitchPending] = useState(false);

    // 라우트 트리가 프로젝트 메뉴 설정(표준/custom)에 따라 배타적으로 바뀌므로 SPA 이동 대신 전체 리로드로 전환
    const onClickSwitchProject = async () => {
        if (!assetProject?.id || !asset.data?.id || switchPending) return;
        setSwitchPending(true);
        try {
            const { data } = await getSettingsAPI(stage.id, stage.endpoint, assetProject.id, {
                resource: "MenuName",
            });
            const isCustomMenuProject = data?.MenuName?.selectMenu?.value === "custom";
            const path = isCustomMenuProject
                ? menuService.paths.customMenuSets.assetsAssetDetail(spaceId, assetProject.id, asset.data.id)
                : menuService.paths.assetsAssetDetail(spaceId, assetProject.id, asset.data.id);
            window.location.href = `${window.location.origin}${path}?projectId=${assetProject.id}`;
        } catch (e) {
            console.error(e);
            dispatch(setProject({ id: assetProject.id, name: assetProject.name }));
            window.location.href = `${window.location.origin}/`;
        }
    };

    return (
        <>
            <Grid container className={"breadcrumb"}>
                <Breadcrumbs separator={"/"}>{list}</Breadcrumbs>
                {assetProject && location.pathname.includes("assets/assets/") && differentProject ? (
                    <span className="badge-project">
                        <strong>{t(`common::label::Read Only`, `Read Only`)}</strong>
                        <Button
                            variant={"text"}
                            size={"small"}
                            disableRipple
                            onClick={onClickSwitchProject}
                            sx={{
                                color: "common.white",
                                textDecoration: "none",
                                minWidth: 0,
                                p: 0,
                                lineHeight: "30px",
                                "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
                            }}
                        >
                            {switchPending
                                ? t(`common::label::Switching`, `Switching`)
                                : t(`common::label::Switch`, `Switch`)}
                        </Button>
                    </span>
                ) : (
                    ""
                )}
            </Grid>
        </>
    );
};
// BreadCrumb.propType = {
// };

export default BreadcrumbsWithRouterPath;
